export default "__VITE_ASSET__CQLgAds___"